module.exports = __webpack_public_path__ + "static/img/icon_float_sub.e5bbe83a.png";